import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "src/store/slices/authentication/auth.slice";
import { AuthFlowResult } from "./types";
import {
  READY_MESSAGE_TYPE,
  AUTH_TOKEN_MESSAGE_TYPE,
  AUTH_FAILED_MESSAGE_TYPE,
  AuthTokenMessagePayload,
} from "./postMessageTypes";
import { isAllowedOrigin, postMessageToParent } from "./originUtils";

export default function useIntegratedFlow(enabled: boolean): AuthFlowResult {
  const [isFetching, setIsFetching] = useState(enabled);
  const [error, setError] = useState<unknown>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled) return;

    setIsFetching(true);

    function handleMessage(event: MessageEvent) {
      if (!isAllowedOrigin(event.origin)) return;
      const { type, payload } = (event.data ?? {}) as { type?: string; payload?: AuthTokenMessagePayload };
      if (type !== AUTH_TOKEN_MESSAGE_TYPE) return;

      if (!payload?.token) {
        setError(new Error("Integrated auth message missing token"));
        setIsFetching(false);
        postMessageToParent({ type: AUTH_FAILED_MESSAGE_TYPE });
        return;
      }

      dispatch(login(payload.token));
      setIsFetching(false);
    }

    window.addEventListener("message", handleMessage);
    postMessageToParent({ type: READY_MESSAGE_TYPE });

    return () => window.removeEventListener("message", handleMessage);
  }, [enabled, dispatch]);

  return { isFetching: enabled && isFetching, error };
}
